enum ContentTypes {
    Guidelines = 1,
    Contacts = 2,
    Admission = 3,
    TermsOfService = 4
}

export class ContentTypesEnum_class {
    public static enum = ContentTypes;

    public static readonly enumByText: {[key: string]: number} = {
        'Guidelines': 1,
        'Contacts': 2,
        'Admission': 3,
        'Terms of Service': 4
    }

    public static readonly enumByNumber: {[key: number]: string} = {
        1: 'Guidelines',
        2: 'Contacts',
        3: 'Admission',
        4: 'Terms of Service'
    }
}